import ZwxSelectArea from './Index.vue'

ZwxSelectArea.install = function(Vue) {
  Vue.component(ZwxSelectArea.name, ZwxSelectArea)
}

export default ZwxSelectArea
